// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"style_cardBody__yXPQB"};